<template>
  <div>
    <v-head></v-head>
    <div class="detail_bg">
      <img src="../assets/pic03.png" alt="">
      <div class="detail_txt">
        <div class="title">
          用户停电互动智能管理系统
        </div>
        <div class="txt">
          User outage interactive intelligent management system
        </div>
      </div>
    </div>
    <div class="detail_content">
      <div>
        <div class="title">项目概况</div> 
        <div class="txt">
          <p>项目针对国网上海供电公司管辖区域内的运行要求，2021年8月5日和8月6日在国网上海市供电公司市南供电公司指定区域内进行测
试，在“所属35kv变电站及母线”、“上级35kv变电站10kv出线”、“10kv线路”分别为“永福站10kv一母”、“永15永福甲”、“85吴兴南”的线
路上分别发布了预计停电计划通知和故障停电计划通知测试。测试用户在程序中注册绑定之后均可以正常接收到计划停电通知。同时模拟
管理员发布故障停电通知，在发布故障停电通知的同时就将故障停电通知发送给了用户，用户正常收到停电通知，数据传输无丢失，程序
运行正常。</p>
        </div> 
      </div>
      <div>
        <div class="title">软件应用图示</div> 
        <div class="img_one">
          <div class="list_one">
            <img src="../assets/img31.png" alt="">
            <div class="txt">该页面显示了微信小程序向用户推送停电消息</div>
          </div>
          <div class="list_one">
            <img src="../assets/img32.png" alt="">
            <div class="txt">该页面是该小程序的首页</div>
          </div>
        </div> 
        <div class="img_one">
          <div class="list_one">
            <img src="../assets/img33.png" alt="">
            <div class="txt">该页面是小程序的发布停电计划和抢修计划页面</div>
          </div>
          <div class="list_one">
            <img src="../assets/img34.png" alt="">
            <div class="txt">该页面是管理员查询用户停电相关的信息页面</div>
          </div>
        </div> 
      </div>
    </div>
    <v-foot class="detail_foot"></v-foot>
  </div>
</template>
<script>
import router from '../router/index.js'
export default {
  methods: {
    gotoHome() {
      router.push('/')
    }
  }
}
</script>
<style scoped>

.head {
  position: absolute;
  background-color: #000;
  height: 75px;
  top: 0;
  width: 100%;
}
.head img {
  margin-top: 10px;
  width: 55px;
  height: 57px;
  margin-left: 20px;
}
.detail_bg img {
  margin-top: 75px;
  width: 100%;  
  height: 600px;  
}
.detail_txt {
  position: absolute;
  top: 280px;
  left: 350px;
  color: #fff ;
}
.detail_txt .title {
  font-size: 58px;
}
.detail_txt .txt {
  margin-top: 32px;
  font-size: 32px;
}
.detail_text {
  display: flex;
}
.detail_content {
  width: 1000px;
  margin: 0 auto;
  color: #666;
}
.detail_content .title {
  font-size: 24px;
  margin-top: 40px;
}
.detail_content .txt {
  margin-top: 15px;
}
.detail_content .txt p {
  font-size: 16px;
  text-indent: 2em;
  margin-top: 3px
}
.img_one {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  width: 1000px;
  flex: 2;
  justify-content: space-between;
  margin-top: 20px;
}
.img_one img {
  width: 450px;
  height: 450px;
}
.list_one {
  margin-bottom: 20px;
}
.list_one .txt {
  text-align: center;
  margin: 20px 0;
  font-size: 14px;
}
.detail_foot {
  margin-top: 50px;
}

</style>


// WEBPACK FOOTER //
// src/components/Detail2.vue